// extracted by mini-css-extract-plugin
export default {"group":"lp4v2F"};